import { Control, useFieldArray } from "react-hook-form"
import { INPUT_FIELD_USAGE } from '../../../../containers/common/constant/projectMst'
import { Inputs } from '../../../../containers/facilityReservationForm/facilityReservationFormService'
import { GItem } from "../../common/grids"
import { ButtonS } from '../../common/buttons/buttonS'
import { AttachedDocUploadField } from './attachedDocUploadField'
import { translate } from '../../../../i18n'
import { AttentionLabel } from '../../common/attentionLabel';
import { TitleLabel } from '../../common/titleLabel';

export interface AttachedDocFieldProps {
    childNum: number
    attachedDocInput: string
    control: Control<Inputs>
}

const AttachedDocField = (props: AttachedDocFieldProps) => {
    const { childNum, attachedDocInput, control } = props;
    
    const uploadName = `children.${childNum}.attachedDoc.docs` as `children.${number}.attachedDoc.docs`
    const { fields, append } = useFieldArray({
        name: uploadName,
        control,
    })
    
    const isOptional = attachedDocInput === INPUT_FIELD_USAGE.OPTIONAL

    return (
        <GItem xs={12}>
            <TitleLabel>
                {
                    !isOptional && (
                        <AttentionLabel>*</AttentionLabel>
                    )
                }
                {translate("facilityReservationForm.form.label.attachedDoc.field")}
            </TitleLabel>
            {/** 施設備考 */}
            <div>
                {fields.map((item, docIndex) => (
                    <AttachedDocUploadField
                        key={item.id}
                        name={`${uploadName}.${docIndex}`}
                        registeredFileKey={item.tempUploadKey}
                    />
                ))}
                {fields?.length < 3 && (
                    <GItem
                        xs={12}
                        mt={1}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        <ButtonS
                            sx={{ width: 'fit-content' }}
                            onClick={() => append({
                                fileName: null,
                                delFlg: '0',
                                tempUploadKey: null,
                            })}
                        >
                            {translate('facilityReservationForm.form.common.add')}
                        </ButtonS>
                    </GItem>
                )}
            </div>
        </GItem>
    );
}

export default AttachedDocField;